import React from 'react';

import { TalentTrackerSidebarItem } from '@interfaces/projects';

import SidebarSection from './SidebarSection';

interface SidebarProps {
  takeaways: TalentTrackerSidebarItem[];
  readMoreItems: TalentTrackerSidebarItem[];
}

const Sidebar = ({ takeaways, readMoreItems }: SidebarProps) => {
  return (
    <section className="mt-56 flex flex-col items-start justify-start border-0 border-solid border-grayscale-gray md:ml-48 md:mt-0 md:border-l md:pl-48 lg:ml-56 lg:pl-56">
      {takeaways.length > 0 && <SidebarSection header="Takeaways" items={takeaways} />}
      {readMoreItems.length > 0 && (
        <SidebarSection className="mt-40 md:mt-48" header="Read More" items={readMoreItems} />
      )}
    </section>
  );
};

export default Sidebar;
